import React, { useState } from 'react'
import Icon from 'components/Icon'
import messages from './messages'
import { FormattedMessage, useIntl } from 'react-intl'

const Text = ({ attribute, interimState, state, onChange }) => {
  const [errors, setErrors] = useState([])
  const { key, name, options, disabled } = attribute
  const { formatMessage } = useIntl()

  const onInputChange = ({ target: { value } }) => {
    if (options && 'tests' in options) {
      let errs = []

      Object.entries(options.tests).map(([regex, err]) => {
        const regexp = new RegExp(regex, 'i')
        if (value.match(regexp) === null) {
          errs.push(err)
        }
      })

      setErrors(errs)
    }

    onChange(value)
  }

  return (
    <fieldset className="space-y-1">
      <p className="text-xs font-medium text-gray-600 uppercase tracking-wider">
        { name }
      </p>

      <input
        type="text"
        disabled={disabled}
        placeholder={options?.placeholder || formatMessage(messages.placeholder, { name: name.toLowerCase() })}
        value={interimState || state || ''}
        onChange={onInputChange}
        className={`w-full p-2 px-3 focus:border-primary transition duration-200 border border-gray-300 ${disabled ? 'bg-gray-100 cursor-not-allowed' : ''}`}
      />

      { state && state.length && errors.map((error) => (
        <small className="text-sm font-medium text-blue-500 block">
          { error } <Icon icon="exclamation-circle" />
        </small>
      )) }
    </fieldset>
  )
}

export default Text
